import { MedosClient } from "../client/MedosClient";
import { ENDPOINTS } from "../constants/endpoints";
import { toWireChannel } from "../types/otpChannel";
function toWireBody(payload) {
    const channel = payload.channel === "email" ? "email" : "phone";
    return channel === "email"
        ? { channel: toWireChannel(channel), email: payload.email }
        : {
            channel: toWireChannel(channel),
            countryCode: payload.countryCode,
            phoneNumber: payload.phoneNumber,
        };
}
const OtpService = {
    async sendOtp(payload) {
        const client = await MedosClient.ensureInitialized();
        const res = await client.post(ENDPOINTS.otp.send, toWireBody(payload));
        return res.data;
    },
    async verifyOtp(payload) {
        const client = await MedosClient.ensureInitialized();
        const res = await client.post(ENDPOINTS.otp.verify, {
            ...toWireBody(payload),
            otpCode: payload.otpCode,
        });
        return res.data;
    },
};
export { OtpService, };
